export class CaseCommentModel{
    public CaseId:string;
    public CommentId:string;
    public UserId:string;
    public IsUserAdmin:boolean;
    public Username:string;
    public CreationDate:string;
    public CommentMessage:string;
    public IsResolved:boolean;
    public UsersRead:any[];
}